











































































































































































import { $eventsBus } from "@/main";
import { VPopover, VClosePopover } from "v-tooltip";
import _ from "lodash";
import { parseStoreStateToWorkspaceSnapshot } from "@/app/shared/utils/utils.js";

export default {
  name: "TopMenu",
  components: {
    VPopover,
  },
  directives: {
    "close-popover": VClosePopover,
  },
  data: function () {
    return {
      canUndo: false,
      canRedo: false,
    };
  },
  computed: {
    undoRedoHistory: function () {
      return this.$undoRedoHistory;
    },
    deletedObjects: function () {
      return this.$store.state.deletedObjects;
    },
    userInfo: function () {
      return this.$store.state.userInfo;
    },
    muted: {
      // getter
      get: function () {
        return this.$store.state.muted;
      },
      // setter
      set: function (newValue) {
        this.$store.commit("muted", newValue);
      },
    },
    snapshot: {
      get() {
        return this.$store.state.snapshot;
      },
    },
    isSaved: function () {
      const currentState = _.cloneDeep(
        parseStoreStateToWorkspaceSnapshot(this.$store.state)
      );
      return _.isEqual(this.snapshot, currentState);
    },
    keymap: function () {
      return {
        "ctrl+z": this.undo,
        "command+z": (event) => {
          if (!event.metaKey) {
            return;
          }
          this.undo();
        },
      };
    },
    currentVideoResolutionLetter: function() {
      if (this.$store.getters.selectedItem) {
        return this.$store.getters.selectedItem.currentVariation.currentSize.name
      }
      return null
    },
  },
  watch: {
    "undoRedoHistory.currentIndex": {
      handler(val) {
        this.canUndo = this.undoRedoHistory.canUndo();
        this.canRedo = this.undoRedoHistory.canRedo();
        //this.$forceUpdate();
      },
    },
  },
  methods: {
    gridPopupButtonClickHandler() {
      let popupWindow = document.querySelector('.grids-popup')
      popupWindow.classList.toggle('grids-popup--opened')
    },
    gridsRadioChangeHandler(event) {
      let radioButtonsCollection = document.querySelectorAll('.grids-popup__grid-name')
      radioButtonsCollection.forEach((button) => {
        button.classList.remove('grids-popup__grid-name--checked')
      })
      event.target.parentElement.classList.add('grids-popup__grid-name--checked')

      this.$store.commit('changeOpenedGridType', event.target.value)
    },
    gridPopupBackgroundClickHandler() {
      let popupWindow = document.querySelector('.grids-popup')
      popupWindow.classList.toggle('grids-popup--opened')
    },

    // legacy
    /*     undo() {
      this.$store.commit("undoDeleteObjects");
      $eventsBus.$emit("saveUserWorkspace");

      //TODO test yandex metrik
      try {
        if (this.$metrika) {
          this.$metrika.reachGoal("undo");
        }
      } catch (e) {
        console.error(e);
      }
	}, */
    undo() {
      if (
        !this.canUndo //||
        //if one of modal window is open
        /* Object.keys(this.$store.getters.modalWindows).some(
          (k) => this.$store.getters.modalWindows[k]
        ) */
      ) {
        return;
      }
      this.$store.commit("undo");
      $eventsBus.$emit("saveUserWorkspace", true);
    },
    redo() {
      if (
        !this.canRedo //||
        //if one of modal window is open
        /* Object.keys(this.$store.getters.modalWindows).some(
          (k) => this.$store.getters.modalWindows[k]
        ) */
      ) {
        return;
      }
      this.$store.commit("redo");
      $eventsBus.$emit("saveUserWorkspace", true);
    },
    muteClick() {
      this.muted = !this.muted;

      //TODO test yandex metrik
      try {
        if (this.$metrika) {
          this.$metrika.reachGoal("mute");
        }
      } catch (e) {
        console.error(e);
      }
    },
    openMenu() {
      this.$refs.arrow.click();
    },
    logout() {
      this.$store.state.userInfo.sessionId = null;
      this.$cookies.remove("sessionId");
      this.$router.push("/login");
      this.$store.state.userInfo.id = -1;
      this.$store.state.userInfo.firstName = "";
      this.$store.state.userInfo.lastName = "";

      //TODO test yandex metrik
      try {
        if (this.$metrika) {
          this.$metrika.reachGoal("logout");
        }
      } catch (e) {
        console.error(e);
      }
    },
    getUserNameInitials() {
      return this.userInfo.avatar
        ? ""
        : this.userInfo.firstName !== "" && this.userInfo.lastName !== ""
        ? this.userInfo.firstName[0].toUpperCase() +
          this.userInfo.lastName[0].toUpperCase()
        : "R";
    },
    saveUserWorkspaceManually() {
      if (this.isSaved) {
        return;
      }
      $eventsBus.$emit("saveUserWorkspace", true);
    },
  },
};
